<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr">
        <span>Occupancy</span>
        <span v-copy="getAllOptionName29('prop_insured', quoteForm.prop_insured)">{{ getAllOptionName29('prop_insured', quoteForm.prop_insured) }}</span>
      </div>
      <div class="tr">
        <span>Type of Building </span>
        <span v-copy="getAllOptionName29('bldg_types', quoteForm.bldg_typ)">{{ getAllOptionName29('bldg_types', quoteForm.bldg_typ) }}</span>
      </div>
      <div class="tr">
        <span>Gross Floor Area</span>
        <span v-copy="quoteForm.floor_area">{{ quoteForm.floor_area }}</span>
      </div>
      <div class="tr">
        <span>Sum Insured of Building Structure</span>
        <span v-copy="amount">{{  quoteForm.bsc_sum_insured | formatMoney(2, true) }}</span>
      </div>
      <!--      <div class="tr">-->
      <!--        <span>Coverage </span>-->
      <!--        <span>{{ getAllOptionName29('coverage', quoteForm.coverage_id) }}</span>-->
      <!--      </div>-->
      <div class="tr">
        <span>Do you need us to post a copy of the policy document to the Mortgagee?</span>
        <span v-copy="getOptionName('yesNoOptions', quoteForm.post_ind)">{{getOptionName('yesNoOptions', quoteForm.post_ind)}}</span>
      </div>
      <div
        v-if="quoteForm.post_ind == 1"
        class="tr">
        <span>Name of Mortgagee</span>
        <span v-copy="quoteForm.post_nm">{{quoteForm.post_nm}}</span>
      </div>
      <div
        v-if="quoteForm.post_ind == 1"
        class="tr">
        <span>Address of Mortgagee</span>
        <span v-copy="quoteForm.post_addr">{{ quoteForm.post_addr}}</span>
      </div>
      <div class="tr">
        <span>Property Age </span>
        <span v-copy="getAllOptionName29('prop_age', quoteForm.prop_age)">{{ getAllOptionName29('prop_age', quoteForm.prop_age) }}</span>
      </div>
      <div class="tr">
        <span>More Benefits</span>
        <span v-copy="getAllOptionName29('benefits', quoteForm.benefits)">{{ getAllOptionName29('benefits', quoteForm.benefits) }}</span>
      </div>
      <div
        v-if="underwriting.length"
        class="tr">
        <span>
          <p
            v-for="(item,index) in underwriting"
            :key="index"
            v-copy="item.name">
            {{item.name}}
          </p>
        </span>
        <span v-copy="getOptionName('answerList', quick_quote_detail.underwriting_confirm)">{{ getOptionName('answerList', quick_quote_detail.underwriting_confirm) }}</span>
      </div>
      <div
        v-if="benefits.length>0"
        class="tr">
        <span>Insured Items</span>
        <span>
          <span
            v-for="(item,index) in benefits"
            :key="'b'+index"
            v-copy="item">
            {{item}}<br>
          </span>
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import OMath from '@/utils/math'

export default {
  name: 'HousemaidQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed:{
    amount(){
      let {bsc_sum_insured} = this.quoteForm||{}
      return  OMath.formatMoney(bsc_sum_insured, 2,true)
    },
    underwriting(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail.underwriting||[]
    },
    quick_quote_detail(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail||{}
    },
    benefits(){
      let {class_id,benefits=[]} = this.quoteForm||{}
      const benefitsList = benefits.reduce((result, item) => {
        result.push(
          this.getAllOptionName29('benefits', item)
        )
        return result
      }, [])
      return benefitsList
    }
  },
  created(){
  }
}
</script>
<style lang="scss" scoped>
</style>
